<template>
    <div v-if="showMenu" class="context-menu" @mouseup.stop :style="{
        left: `${menuPosition.left}px`,
        top: `${menuPosition.top}px`
    }">
        <div
            v-if="!isCommentDisabled && (documentData.documentType === 'PR' || documentData.documentType === 'BUISNESS_NARRATVE')">
            <div class="title">
                Make Changes
            </div>
            <div class='menu-item' @click="openCommentDialog()">
                <div class="item-content">
                    <img :src="require('@/assets/icons/commentIcon.svg')" />
                    <div>Add <span>Comment</span></div>
                </div>
                <Svg class="plus-icon" :src="require('@/assets/icons/plus-icon.svg')" fill="#DF009E"></Svg>
            </div>
        </div>

        <div v-else-if="shouldShowOverlapInfo && !isVersionLocked && (documentData.documentType === 'PR' || documentData.documentType === 'BUISNESS_NARRATVE')" class="disabled-menu">
            <div class="title">Content overlap detected.</div>
            <div class="menu-item">
                <div class="item-content">
                    <img class="info-icon black" :src="require('@/assets/icons/info-icon.svg')" />
                    <div>
                        Delete the existing comment and reselect the content.
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isArticleAllowed">
            <div class="title">
                Use key text to focus
            </div>
            <!-- <div class='menu-item' @click="handleAction('social-media-post')">
                <div class="item-content">
                    <img :src="require('@/assets/icons/social-media-black.svg')">
                    <div>Generate <span>Social Media Campaign</span></div>
                </div>
                <Svg class="plus-icon" :src="require('@/assets/icons/plus-icon.svg')" fill="#DF009E"></Svg>
            </div> -->
            <div class='menu-item' @click="handleAction('article')">
                <div class="item-content">
                    <img :src="require('@/assets/icons/article-black.svg')">
                    <div>Create <span>Articles</span></div>
                </div>
                <Svg class="plus-icon" :src="require('@/assets/icons/plus-icon.svg')" fill="#DF009E"></Svg>
            </div>
        </div>
    </div>
    <div v-if="showCommentDialog" class="comment-popup" @mouseup.stop :style="{
        left: `${menuPosition.left}px`,
        top: `${menuPosition.top}px`
    }">
        <div class="comment-header">
            <img class="comment-icon" :src="require('@/assets/icons/commentIcon.svg')" />
            <span>Add Comment</span>
        </div>
        <div class="comment-body">
            <textarea class="comment-input" placeholder="eg: Rephrase the paragraph" v-model="commentText"></textarea>
        </div>
        <div class="comment-actions">
            <button class="discard-btn" @click="closeCommentDialog">
                Discard
            </button>
            <button class="add-btn" :disabled="!commentText" @click="addComments()">
                Add Comment
                <v-progress-circular v-if="btnLoader" indeterminate :size="18" :width="2"></v-progress-circular>
            </button>
        </div>
    </div>

    <v-overlay :model-value="pageLoader" class="overlay" persistent="true">
        <RotatingLoader :size="30" :speed="0.6" />
    </v-overlay>
</template>

<script>
import axiosInstance from '@/axiosInterceptor';
import { Eventbus } from '@/plugins/eventBus';
import RotatingLoader from '@/components/CircularProgressBar.vue';

export default {
    props: {
        showMenu: Boolean,
        menuPosition: {
            type: Object
        },
        documentData: {
            type: Object,
        },

        version: String,
        commentedLength: Number,
        isCommentDisabled: Boolean,
        isArticleAllowed: Boolean,
        isVersionLocked:Boolean,
        shouldShowOverlapInfo:Boolean
    },
    components: {
        RotatingLoader
    },
    data() {
        return {
            docName: null,
            pageLoader: false,
            showCommentDialog: false,
            commentText: '',
            btnLoader: false,
        }
    },
    watch: {
        version() {
            this.forceClose()
        }
    },
    methods: {
        forceClose() {
            this.showCommentDialog = false
            this.commentText = ''
            this.$emit('close')
            const sel = window.getSelection()
            if (sel) sel.removeAllRanges()
        },


        async handleAction(action) {
            if (action === 'article') {
                await this.addNewArticle();

            }
            this.$emit('close');
        },
        async saveArticleDraft(articleId) {
            let endpoint = '/article/saveDraft'
            let payload = {
                articleId: articleId,
            }
            let documentData = {};
            documentData = {
                documentType: this.documentData.documentType,
                documentId: this.documentData.documentId,
                articleId: this.articleId,
                section: this.documentData.sectionContent,
            };

            payload.lastUpdatedStage = 'SOURCE_DOC';
            payload.documentData = documentData


            await axiosInstance.put(endpoint, payload)
                .then((response) => {
                    this.showArticleStage = true;
                    this.$router.push({ name: 'ArticleStages', params: { articleId: articleId }, state: { locked: true } });
                    this.pageLoader = false
                })
                .catch((error) => {
                    console.error('[ERROR] ', error);
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to save changes',
                    });
                })
        },
        async addNewArticle() {
            this, this.pageLoader = true
            let payload = {
                articleDocumentName: this.docName,
            }
            let endpoint = '/article/create';
            await axiosInstance.post(endpoint, payload)
                .then(async (response) => {
                    this.articleId = response.data.data.articleId;
                    await this.saveArticleDraft(this.articleId)
                })
                .catch((error) => {
                    Eventbus.emit({
                        snackType: 'error',
                        message: 'Failed to create new article'
                    })
                })

        },
        openCommentDialog() {
            this.showCommentDialog = true;
            this.$emit('close');
        },

        closeCommentDialog() {
            this.showCommentDialog = false;
            this.commentText = '';
        },

        async addComments() {
            try {
                this.btnLoader = true;
                const payload = { ...this.documentData, comments: this.commentText };

                const result = await axiosInstance.post('/comments/add', payload);

                if (result.status == 200) {
                    const newComment = {
                        commentId: result.data?.data.commentId,
                        comments: this.commentText,
                        createdAt: new Date(),
                        selectedText: this.documentData.sectionContent,
                        status: 'ACTIVE'
                    };
                    this.$emit('comment-added', newComment);
                    Eventbus.emit('commonSnackbar', { snackType: 'save', message: 'Comments added successfully' });
                    this.showCommentDialog = false;
                    this.commentText = ''

                }
            } catch (error) {
                Eventbus.emit('commonSnackbar', { snackType: 'error', message: 'Unable to add comments' });
            } finally {
                this.btnLoader = false;
            }
        },

        // async suggestArticle() {

        //     try {
        //         this.pageLoader = true;
        //         const payload = {
        //             documentType: this.documentData.documentType,
        //             documentId:this.documentData.documentId,
        //             articleId: this.articleId,
        //             sectionContent: this.documentData.sectionContent,
        //         };
        //         const response = await axiosInstance.post('/article/suggest', payload);
        //         if (response.status === 201) {
        //             this.$router.push({ name: 'ArticleStages', params: { articleId: this.articleId } });
        //         }
        //     } catch (error) {
        //         console.error("Error generating Article", error);
        //         Eventbus.emit('commonSnackbar', {
        //             snackType: 'error',
        //             message: 'Something went wrong, Please try again!',
        //         });
        //     } finally {
        //         this.pageLoader = false;

        //     }
        // },
    },
    computed: {

    }
}
</script>

<style scoped>
.context-menu {
    position: absolute;
    background: white;
    border-radius: 8px;
    border: 1px solid #E5E5E5;
    padding: 8px;
    z-index: 1000;
    min-width: 350px;
}

.title {
    color: #171717;
    padding: 4px 12px;
    font-size: 14px;
    font-style: bold;
}

.menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #171717;
    padding: 10px 12px;
    cursor: pointer;
    border-bottom: 1px solid #E5E5E5;
    background-color: #F5F5F5;
}

.menu-item:last-child {
    border-bottom: none;
}

.menu-item:hover {
    background-color: #f5f5f5;
}

.item-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.info-icon.black {
    filter: brightness(0);
}

span {
    font-weight: 600;
    font-style: Semi Bold;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -3%;
}

.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.comment-popup {
    position: absolute;
    width: 450px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    overflow: hidden;
}

.comment-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 14px;
    font-size: 14px;
    font-weight: 600;
    border-bottom: 1px solid #e5e7eb;
}

.comment-icon {
    width: 16px;
    height: 16px;
}

.comment-body {
    padding: 12px 14px;
}

.comment-input {
    width: 100%;
    min-height: 120px;
    resize: none;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 10px;
    font-size: 14px;
}

.comment-input::placeholder {
    color: #9ca3af;
}

.comment-actions {
    display: flex;
    gap: 12px;
    padding: 12px 14px;
    border-top: 1px solid #e5e7eb;
}

.discard-btn {
    flex: 1;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px 0;
    font-weight: 500;
    cursor: pointer;
}

.add-btn {
    flex: 1;
    background: #a3a3a3;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    padding: 8px 0;
    font-weight: 500;
    cursor: pointer;
}

.add-btn:enabled {
    background: var(--primary-font-color);
}
</style>